import axios from 'axios';

// ✅ API 1: SAD (API original - mantém compatibilidade)
const api = axios.create({
    baseURL: "https://api.afrafepsaude.com.br"
});

// ✅ API 2: Sisclinic (nova API)
const sisclinicAPI = axios.create({
    baseURL: "https://api.afrafepsaude.com.br/sisclinic"
});

// ============================================================================
// INTERCEPTORS PARA A API SISCLINIC (NOVA API)
// ============================================================================

sisclinicAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Frontend");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const contentType =
      config.headers?.["Content-Type"] || config.headers?.["content-type"];
    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;
    if (!contentType && !isFormData) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

sisclinicAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Token expirado ou inválido para API Sisclinic');
      // Você pode adicionar redirecionamento para login aqui se necessário
    }
    return Promise.reject(error);
  }
);

// ============================================================================
// INTERCEPTORS PARA A API SAD (API ORIGINAL)
// ============================================================================

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("Frontend");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const contentType =
      config.headers?.["Content-Type"] || config.headers?.["content-type"];
    const isFormData =
      typeof FormData !== "undefined" && config.data instanceof FormData;
    if (!contentType && !isFormData) {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error('Token expirado ou inválido para API SAD');
    }
    return Promise.reject(error);
  }
);

// ============================================================================
// EXPORTS
// ============================================================================

export default api; // API SAD (para compatibilidade)
export { sisclinicAPI }; // Nova API Sisclinic
